import useGlobalInit from "@components/_hooks/InitHooks/useGlobalInit"
import useRouteHandler from "@components/_hooks/InitHooks/useRouteHandler";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

const InitData = ({pagePropsData, sidenav = 'no'}) => {
   
	const dispatch = useDispatch();
	const {initGlobal} = useGlobalInit();
	const {initRouteHandler} = useRouteHandler();

	useEffect(() => {
		initGlobal();
		initRouteHandler();
	}, [])

	useEffect(() => {
		const payload = {
			sidenav: pagePropsData?.template_page_settings?.sidenav == 'yes' && sidenav == 'yes'
		}

		dispatch({
			type: "SET_GLOBAL_DATA",
			payload: payload
		})
    }, [pagePropsData])
    
}

export default InitData